import React from 'react';
import { gigData } from '../App';
import '../styles/index.css';

function Index() {
  // Collect all images from all gigs and categories
  const allImages = gigData.flatMap(gig => {
    const images = [
      ...gig.images.originals.map(src => ({
        src,
        gig: gig.bandName,
        category: 'originals'
      })),
      ...gig.images.bw.map(src => ({
        src,
        gig: gig.bandName,
        category: 'b&w'
      }))
    ];
    return images;
  });

  return (
    <div className="index-page">
      <div className="index-grid">
        {allImages.map((image, idx) => (
          <div key={idx} className="index-item">
            <img
              src={process.env.PUBLIC_URL + image.src}
              alt={`${image.gig} - ${image.category}`}
              loading="lazy"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Index; 